"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _epics = require("settings-ui-sdk/DesignTemplates/epics");

var _epics2 = require("settings-ui-sdk/SitePages/epics");

var _UpdateSiteSettings = _interopRequireDefault(require("../stagedObjects/UpdateSiteSettings"));

var _default = (0, _reduxObservable.combineEpics)(_epics.fetchMembershipTemplates, _epics2.fetchPublishedSitePages, _epics2.fetchPublishedSitePagesById, _UpdateSiteSettings.default.getResetChangesToStagedObjectEpic());

exports.default = _default;
module.exports = exports.default;